import React from 'react';
import { useTranslation } from '../../i18n/useTranslation';

export default function EllaRadioBansError({ kind, onRetry }) {
  const { t } = useTranslation();
  return (
    <div role="alert" style={{ margin: '0 0 8px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
      <p style={{ margin: 0, fontSize: 13, color: '#ef4444' }}>{t(`ellaBans.error.${kind}`)}</p>
      <button
        type="button"
        onClick={onRetry}
        style={{
          padding: '4px 10px', borderRadius: 8, fontSize: 11, fontWeight: 600, flexShrink: 0,
          background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)',
          color: 'var(--text-secondary)', cursor: 'pointer',
        }}
      >
        {t('ellaBans.retry')}
      </button>
    </div>
  );
}
